import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--events--performances--master-tickets"
export default class extends Controller {
  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const ticketName = event.currentTarget.dataset.ticketName;
    const url = event.currentTarget.dataset.url;
    const target = document.getElementById(targetId);
    const modalController = this.application.getControllerForElementAndIdentifier(target, "modal");

    target.getElementsByClassName("modal-alert-info__data")[0].textContent = ticketName;
    target.getElementsByClassName("button-alert")[0].href = url;
    modalController.show();
  }

  receptionsModalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const target = document.getElementById(targetId);
    const modalController = this.application.getControllerForElementAndIdentifier(target, "modal");

    modalController.show();
  }
}
